<div class="cell-file-wrapper">
  <div class="text-ellipsis">{{getNameOfFile()}}</div>
</div>
